module.exports = __webpack_public_path__ + "static/img/02.082f519d.png";